import {
  Button,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useLocation, useNavigate } from "react-router-dom";
import SpinnerLoader from "../components/spinnerLoader";
import { ForgPasswordSubmit } from "../functions/authenticate";
import bannerBgSVG from "../assets/media/banner_bg.svg";

export default function ChangePassword() {
  const [showPassword, setShowPassword] = useState(false);
  const [showRPassword, setShowRPassword] = useState(false);
  const [codeErr, setCodeError] = useState({ bool: false, value: "" });
  const [code, setCode] = useState(null);
  const [password, setPassword] = useState(null);
  const [rpassword, setRPassword] = useState(null);
  const [passwordErr, setPasswordError] = useState({ bool: false, value: "" });
  const [rpasswordErr, setRPasswordError] = useState({
    bool: false,
    value: "",
  });
  const [userid, setUserId] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [load, setLoad] = useState(false);

  const checkPassword = async (pass) => {
    const re = new RegExp(
      "^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})"
    );
    let test = re.test(pass);
    if (test) {
      setPasswordError({ bool: false, value: "" });
      return true;
    } else {
      setPasswordError({ bool: true, value: "Weak Password" });
      return false;
    }
  };

  const checkRPassword = async (pass) => {
    if (password == pass) {
      setRPasswordError({ bool: false, value: "" });
      return true;
    } else {
      setRPasswordError({ bool: true, value: "Password does'nt match" });
      return false;
    }
  };

  const validateFields = async () => {
    if (!code) {
      setCodeError({ bool: true, value: "Invalid Code" });
      return false;
    } else {
      setCodeError({ bool: false, value: "" });
    }
    const checkPass = await checkPassword(password);
    if (!checkPass) {
      return false;
    }
    const checkRPass = await checkRPassword(rpassword);
    if (!checkRPass) {
      return false;
    }
    return true;
  };
  const onSubmit = async (event) => {
    event.preventDefault();
    let validate = await validateFields();
    if (validate) {
      setLoad(true);
      const signObj = await ForgPasswordSubmit(
        userid,
        code,
        password,
        navigate
      );
      if (signObj) {
        setUserId(null);
      }
    }
    setLoad(false);
  };

  useEffect(() => {
    let { state } = location;
    console.log(location);
    if (state && state.username) {
      setUserId(state.username);
    } else {
      navigate("../login");
    }
  }, [location]);

  const onChangeTxt = async (event, func) => {
    let value = event.target.value;
    func(value);
  };

  return (
    <Grid container>
      <Grid md={6} lg={6} sm={12} xs={12} className="lgcommonBg lgLeftBg" sx={{backgroundImage: `url(${bannerBgSVG})`}}>
        <Grid className="logoDiv">
          <img src="media/logo.svg" className="logoImg" />
        </Grid>
        <Grid className="roboDiv">
          <img src="media/lock_3.svg" className="roboImg" />
        </Grid>
      </Grid>
      <Grid md={6} lg={6} sm={12} xs={12} className="lgcommonBg lgRightBg">
        <div className="insideCont customInside2">
          <h1 className="lgTitle">Reset Password</h1>
          {load ? (
            <SpinnerLoader visible={load} />
          ) : (
            <form onSubmit={onSubmit} onDragEnter={onSubmit}>
              <TextField
                fullWidth
                error={codeErr.bool}
                label="Code"
                className="formtext"
                value={code}
                onChange={(e) => {
                  onChangeTxt(e, setCode);
                }}
                autoComplete={false}
                placeholder="1234"
                helperText={codeErr.value}
              />
              <FormControl className="formtext" fullWidth variant="outlined">
                <InputLabel htmlFor="outlined-adornment-password">
                  Password
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password"
                  fullWidth
                  error={passwordErr.bool}
                  value={password}
                  onChange={(e) => {
                    onChangeTxt(e, setPassword);
                  }}
                  type={showPassword ? "text" : "password"}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => {
                          setShowPassword(!showPassword);
                        }}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Password"
                />
                {passwordErr.bool && (
                  <FormHelperText error id="outlined-adornment-error">
                    {passwordErr.value}
                  </FormHelperText>
                )}
              </FormControl>
              <FormControl className="formtext" fullWidth variant="outlined">
                <InputLabel htmlFor="outlined-adornment-password">
                  Confirm Password
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password"
                  fullWidth
                  error={rpasswordErr.bool}
                  value={rpassword}
                  onChange={(e) => {
                    onChangeTxt(e, setRPassword);
                  }}
                  type={showRPassword ? "text" : "password"}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => {
                          setShowRPassword(!showRPassword);
                        }}
                        edge="end"
                      >
                        {showRPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Confirm Password"
                />
                {rpasswordErr.bool && (
                  <FormHelperText error id="outlined-adornment-error">
                    {rpasswordErr.value}
                  </FormHelperText>
                )}
              </FormControl>

              <Button className="frmbtn" type="submit">
                RESET PASSWORD
              </Button>
            </form>
          )}
        </div>
      </Grid>
    </Grid>
  );
}
